//TODO change gifs
//TODO change skill scores

export const projects = [
  {  
    title: "LinkMe",
    subtitle: "SvelteKit and Firebase",
    description:
      "A linktree copy to allow you to share all your online profiles with one link",
    image: "./LinkMe.gif",
    link: "https://linktree-a232a.web.app"
  },
  {
    title: "Portfolio Website",
    subtitle: "React",
    description:
      "This page",
    image: "./portfolio.gif",
    link: "https://daniel-coates.com",
  },
  {
    title: "Weather Website",
    subtitle: "React and API use",
    description:
      "A simple page to get weather information",
    image: "./weather.gif",
    link: "https://dankoatesweather.netlify.app",
  },
  {
    title: "YouTube Downloader",
    subtitle: "Svelte YouTube downloader",
    description:
      "A Svelte app with a Node backend to download video and audio from YouTube videos",
    image: "./yt.gif",
    link: "https://github.com/danielxoates/yt_downloader",
  },
  {
    title: "Circle Packing GA",
    subtitle: "Genetic Algorithms and OOP",
    description:
      "A fully implemeted genetic algorithm for the circle packing problem. It also has the greedy and random algorithms implemented.",
    image: "./GA.gif",
    link: "https://github.com/danielxoates/circlePacking/tree/main",
  },
  {
    title: "Addiction Recovery App",
    subtitle: "React Native and PHP",
    description:
      "An app designed to help people struggling with addiction, and my dissertation project.",
    image: "./addiction.gif",
    link: "https://github.com/danielxoates/chat_app",
  },
];

export const testimonials = [
  {
    quote:
      "I wanted to take a moment to express my sincere gratitude for your outstanding performance during your two-week internship at KAI."+
        "Your enthusiasm and adaptability during your tenure were truly remarkable. You seamlessly integrated into our fast-paced startup environment and thrived in every aspect. I am particularly impressed with how much you accomplished in such a short period. You successfully improved our confidence model by incorporating Japanese conversations, and your work on common agenda tags using extractive and generative models to find the right questions was exemplary. Additionally, you also worked with me in producing manual tags for GROW model."+
        "Your dedication and hard work have left a lasting impression on all of us. It was a pleasure to work alongside you, and I have no doubt that your future endeavors will be equally successful. I wish you all the best as you continue to excel in your career."+
        "Once again, thank you for your exceptional contribution to KAI.",
    name: "Milan Panera",
    company: "KAI Converations",
  },
  {
    quote:
      "During Daniel’s time with us, he was tasked with abstracting out one of our software services so that it could be replaced. This included wrapping an interface around existing software behaviour and consolidating various parts of the system to access it via an Abstract Factory pattern."+
      "This involved working with both legacy PHP and the Laravel framework, making and handling API calls and processing XML data. This piece ran through the full development cycle from inception to code review, where Daniel managed his changes with Git."+
      "From the start of the project he had a positive attitude towards the work and took his time to understand what he was doing and how he would implement it. He asked relevant questions throughout the process, which displayed the effort that had gone into gaining knowledge of the surrounding processes."+
      "I found Daniel pleasant to work with; friendly and open to feedback. He has a desire to learn and improve and it shows in his interactions. Daniel worked well in a professional environment and was exposed to some of our internal code review meetings to add to his experience."+
      "I hope Daniel feels he benefited from his time with us and believe that if he continues to approach his work with the positivity I’ve seen, he has the potential to make a well rounded team member and engineer.",
    name: "Jon Braud, Senior software engineer",
    company: "Tribepad"
  }
];

export const skills = [
  "JavaScript",
  "React",
  "PHP",
  "Python",
  "MySQL",
  "Git",
  "Rust",
  "Java",
];

export const ratings = [
  4,
  3,
  4,
  2,
  4,
  2,
  3,
  3,
];


// WEBPACK FOOTER //
// ./src/data.js